/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense, useState } from 'react';
import { Button } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { ITaxInvoice } from '@/interfaces/report';
import { ExportOutlined } from '@ant-design/icons';
import { useSetting } from '@/contexts/CompanyContext';
import PrintModal from '@/components/templates/print-tax-invoice-modal';
import { IDataModal } from '@/interfaces/dataModal';
import { ISetting } from '@/interfaces/setting';

interface IProps {
  date: Date | string | Dayjs | null | undefined;
  data: ITaxInvoice[];
}

const _printModal: IDataModal<any> = {
  open: false,
};

const PDFExport = ({ data, date }: IProps) => {
  const { setting } = useSetting();
  const [print, setPrint] = useState<IDataModal<any>>({
    ..._printModal,
  });
  return (
    <div>
      <Button
        type="primary"
        ghost
        onClick={() =>
          setPrint({
            open: true,
          })
        }
      >
        <ExportOutlined /> Export to PDF
      </Button>
      <Suspense>
        <PrintModal
          open={print.open}
          handleCancel={function (): void {
            setPrint({
              ..._printModal,
            });
          }}
          data={data}
          date={dayjs(date).toDate()}
          tms={['TM26']}
          setting={setting as ISetting}
        />
      </Suspense>
    </div>
  );
};

export default PDFExport;
